var _g, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcEntryLevelApproval = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "ic_entry_level_approval") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#6EBD45"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 19,
  width: 5,
  height: 10
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 13,
  width: 5,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 9,
  width: 5,
  height: 20
})))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 9,
  r: 6,
  fill: "#FFFFFF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.3 9.2 L25.3 11.2 L29 6.8",
  fill: "none",
  stroke: "#3F68B5",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcEntryLevelApproval);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_entry_level_approval.ff406bc40772e2ef6326a6eedf3087d0.svg";